module.exports = __webpack_public_path__ + "img/question.328c3bd9.png";